import { supportedColumnTypesArray } from "../data/constants/supportedColumnsNoneStr";
import { isSimbManagedColumnTitle } from "./simbManagedColumns";

export type BoardColumn = { id: string; title: string; type: string };

export type SharedColumnsSplit = {
  /** Origin columns the target has a column with the same title and type for. */
  shared: BoardColumn[];
  /** Origin columns of a supported type with no same title and type column on the target. */
  noMatch: BoardColumn[];
  /** Origin columns of a type SIMB never syncs (formula, mirror, item ID, ...). */
  unsupported: BoardColumn[];
};

// The name always travels as the item name, and subitems have their own "Include Subitems" option.
const IGNORED_TYPES = ["name", "subtasks"];

const SUPPORTED_TYPES: readonly string[] = supportedColumnTypesArray;

/**
 * Splits the origin board's columns by what will happen to them when an item is shared to the
 * target board. Mirrors the sync's own rule: a column syncs when the target has one with exactly
 * the same title and type.
 */
export function splitSharedColumns(
  origin: BoardColumn[],
  target: BoardColumn[],
): SharedColumnsSplit {
  const targetKeys = new Set(target.map((c) => `${c.type}\u0000${c.title}`));
  const split: SharedColumnsSplit = { shared: [], noMatch: [], unsupported: [] };

  for (const column of origin) {
    if (IGNORED_TYPES.includes(column.type) || isSimbManagedColumnTitle(column.title)) continue;

    if (!SUPPORTED_TYPES.includes(column.type)) split.unsupported.push(column);
    else if (targetKeys.has(`${column.type}\u0000${column.title}`)) split.shared.push(column);
    else split.noMatch.push(column);
  }

  return split;
}
